/**
 * i18n-váz — EGY NYELV, DE NULLA BEÉGETETT SZÖVEG.
 *
 * Nem fordítás, hanem SZERKEZET. Ha a komponensekbe beégett magyar szövegek
 * kerülnek, a nyelv utólagos behúzása MINDEN KÉPERNYŐT ÚJRANYIT — pontosan
 * úgy, ahogy a 2.6/16 mondja a billentyűzet-első fókuszkezelésről. Ha viszont
 * az első naptól t()-n megy minden felhasználói szöveg, a fordítás később
 * EGY FÁJL.
 *
 * KÉT NÉVTÉR, és ez kemény szabály (modulterkep.md §3):
 *   common  — enum → felirat, domain-főnevek, Intl-formátumok. MEGOSZTOTT,
 *             a NestJS-szel is: az értesítő levél ugyanazokat az állapotokat
 *             írja le, mint a hiánylista. Ha három helyen készül, a termék
 *             három hangon beszél.
 *   admin — csak EZ a felület. A megosztásuk TILOS: a két felület
 *             szándékosan más nyelvet beszél.
 *
 * A `fallbackNS: 'common'` pontosan azt a feloldást adja, amit az i18n-kapu is
 * mér (`scripts/quality/i18n-gate.sh`) — a kapu és a futásidő ugyanazt látja.
 */

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import surface from './generated/locales/hu/admin.json';
import common from './generated/locales/hu/common.json';

export const DEFAULT_LOCALE = 'hu';

void i18next.use(initReactI18next).init({
  resources: { hu: { common, admin: surface } },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'admin',
  fallbackNS: 'common',
  interpolation: {
    // React maga szökteti a beszúrt értéket.
    escapeValue: false,
  },
});

export default i18next;
